export default "__VITE_ASSET__5Yxva$6L__"